import { render, staticRenderFns } from "./time-reservation-form.vue?vue&type=template&id=60d0a5c2&scoped=true&lang=pug"
import script from "./time-reservation-form.vue?vue&type=script&lang=js"
export * from "./time-reservation-form.vue?vue&type=script&lang=js"
import style0 from "./time-reservation-form.vue?vue&type=style&index=0&id=60d0a5c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d0a5c2",
  null
  
)

export default component.exports